import { JobHeader } from "@/components/job/JobHeader";
import { JobHero } from "@/components/job/JobHero";
import { JobAbout } from "@/components/job/JobAbout";
import {
  JobResponsibilities,
  JobProfile,
} from "@/components/job/JobResponsibilities";
import { JobRequirements } from "@/components/job/JobRequirements";
import { JobInfo, JobTimeline } from "@/components/job/JobInfo";
import {
  JobCandidatura,
  JobFinalCTA,
} from "@/components/job/JobCandidatura";
import { JobFooter, FloatingApplyButton } from "@/components/job/JobFooter";
import { useJobSEO } from "@/hooks/useJobSEO";

export default function JobPage() {
  useJobSEO();

  return (
    <main data-testid="job-page" className="bg-white text-[#1F2937]">
      <JobHeader />
      <JobHero />
      <JobAbout />
      <JobResponsibilities />
      <JobProfile />
      <JobRequirements />
      <JobInfo />
      <JobTimeline />
      <JobCandidatura />
      <JobFinalCTA />
      <JobFooter />
      <FloatingApplyButton />
    </main>
  );
}
